<script setup lang="ts">
defineProps<{
    title: string;
    description: string;
    image: string;
    imageAlt: string;
}>();
</script>

<template>
    <div class="overflow-hidden rounded-lg bg-white shadow-md transition-shadow hover:shadow-lg">
        <div class="relative h-48 overflow-hidden">
            <img :src="image" :alt="imageAlt" class="h-full w-full object-cover" loading="lazy" />
        </div>
        <div class="p-6">
            <h3 class="mb-2 text-xl font-bold text-dark">{{ title }}</h3>
            <p class="text-gray-600">{{ description }}</p>
        </div>
    </div>
</template>
